import { render, staticRenderFns } from "./MenuOcrList.vue?vue&type=template&id=5e3688d0&"
import script from "./MenuOcrList.vue?vue&type=script&lang=js&"
export * from "./MenuOcrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports